import { render } from "./CarruselSucursalesComponent.vue?vue&type=template&id=3983f700&scoped=true"
import script from "./CarruselSucursalesComponent.vue?vue&type=script&lang=js"
export * from "./CarruselSucursalesComponent.vue?vue&type=script&lang=js"

import "./CarruselSucursalesComponent.vue?vue&type=style&index=0&id=3983f700&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3983f700"]])

export default __exports__